<template>
  <div class="wrapper">
    <w-sys-spin
      v-if="loading"
      class="center"
    />
    <w-sys-page
      v-else-if="pageConf"
      :config="pageConf"
      :project-config="projectConfig"
    />
    <div v-else>
      invalid pageId
    </div>
  </div>
</template>

<script>
import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import pageLoader from '@loaders/page/loader';

export default {
  props: {
    projectId: {
      type: String,
      default: '',
    },
    pageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pageConf: null,
      projectConfig: null,
      loading: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      const [pageConf, projectConfig] = await Promise.all([
        this.getPageDetail(this.projectId, this.pageId),
        this.$store.dispatch('runtime/getProject', { projectId: this.projectId, env: window.w.env }),
      ]);
      this.pageConf = pageConf;
      this.projectConfig = projectConfig;
      this.loading = false;
    },
    async getPageDetail(projectId, pageId) {
      try {
        return await pageLoader.getPageDetail({ projectId, pageId });
      } catch (e) {
        message.error($t('k_1217471a', { arg_0: e.message }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100%;

  .center {
    position: absolute;
    top: 50%;
    left: 50%;
  }
}
</style>
